import { APIS } from '../../utils/apiConfig';
import { createRequestUtility } from '../../utils/httpUtils';
import { HttpService } from '../HttpService/HttpService';

export class BillingConsoleService {
  // constructor(private httpService: HttpService) {}
  private makeRequest: ReturnType<typeof createRequestUtility>;

  constructor(private httpService: HttpService) {
    // Initialize makeRequest with the httpService
    this.makeRequest = createRequestUtility(this.httpService);
  }

  async getBillingConsoleReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_BILLING_CONSOLE(), params);
  }

  async getCsvBillingConsoleReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_CSV_BILLING_CONSOLE(), params);
  }
}
